// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"flip-to-front"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M20 4H8V16H20V4Z","fillRule":"evenodd","strokeLinecap":"square","strokeWidth":"props.strokeWidth","clipRule":"evenodd"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M10.5 20H9.5M5.5 20H4V18.5M15.5 20H14.5M4 13.5V14.5M4 8.5V9.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FlipToFrontIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'flip-to-front',
    ref,
    icon: element,
  },
));

FlipToFrontIcon.displayName = 'FlipToFrontIcon';

export default FlipToFrontIcon;
